// Analytics.jsx
import React from "react";

const Analytics = () => {
  const statuses = ["PENDING", "ACTIVE", "INACTIVE", "SOLD_OUT", "DELETED"];

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">Product Statuses</h2>
      <ul className="space-y-2">
        {statuses.map((status) => (
          <li
            key={status}
            className="bg-indigo-100 text-indigo-700 px-4 py-2 rounded-md shadow-sm font-medium"
          >
            {status}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Analytics;
